import { render, staticRenderFns } from "./SleepApnea.vue?vue&type=template&id=53a870ec&"
import script from "./SleepApnea.vue?vue&type=script&lang=js&"
export * from "./SleepApnea.vue?vue&type=script&lang=js&"
import style0 from "./SleepApnea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports